import { Component, OnInit } from '@angular/core';
import { AlertController, NavController, ToastController } from '@ionic/angular';
import { UserData } from '../../../providers/user-data';
import { ActivatedRoute, Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import { UserProfile } from '../../../models/user-profile.model';
import { RoleAccess } from '../../../models/role-access.model';
import { environment } from '../../../../environments/environment';
import * as utf8 from 'crypto-js/enc-utf8';
import AES = require('crypto-js/aes');
import { UtilService } from '../../../service/util.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-customer-detail',
  templateUrl: './customer-detail.page.html',
  styleUrls: ['./customer-detail.page.scss'],
})
export class CustomerDetailPage implements OnInit {

  token: any;
  userProfile: UserProfile = new UserProfile();
  roleAccess = new RoleAccess();
  baseUrl:any;
  customerId:any='0';
  customerData:any;
  countryData:any[]=[];
  cityData:any[]=[];
  districtData:any[]=[];
  subdistrictData:any[]=[];
  provinceData:any[]=[];
  counterData:any[]=[];
  countryId:any=0;
  provinceId:any=0;
  cityId:any=0;
  districtId:any=0;
  subdistrictId:any=0;
  counterId:any=0;
  
  selectedProvince:any[]=[];
  selectedCity:any[]=[];
  selectedDistrict:any[]=[];
  selectedSubdistrict:any[]=[];
  pointHistory:any[]=[];
  phone:any='';
  customerName:any='';
  email:any='';
  identityNumber:any='';
  referralCode:any='';
  firstReceiptNo:any='';
  birthPlace:any='';
  birthDate:any='';
  gender:any='';
  profession:any='';
  address:any='';
  tierName:any='';
  currentPoint:any=0;
  memberVouchers:any[]=[];
  memberHistory:any[]=[];
  showReferralCode:boolean=false;
  tierStartDate:any='';
  status:any='1';
  banReason:any='';
  constructor(
    private activeRoute: ActivatedRoute,
    private utilService: UtilService,
    private alertController: AlertController,
    private navCtrl: NavController,
    private toastCtrl: ToastController,
    private http: HttpClient,
    private storage: Storage,
    private userData: UserData,
    private router: Router
  ) {
      this.baseUrl = environment.apiUrl;
     }

  ngOnInit() {
  }

  ionViewDidEnter() {
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile, access]) => {
      if(token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        this.roleAccess = this.userData.checkAccess(this.router.url, access, this.userProfile);
        if(!this.roleAccess || this.roleAccess.update!='1'){
          this.toastCtrl.create({ duration: 2000, message: 'You Are Not Allowed to Access this Page' }).then(t => t.present());
          this.navCtrl.navigateForward(['/']);
        } 
        this.getData();
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }
   getData() {
      this.activeRoute.queryParams.subscribe((snapshot) => {
        let myKey=environment.myKey;
        this.customerId = AES.decrypt(snapshot.i, myKey).toString(utf8);
        this.utilService.loadingPresent('Harap tunggu...')
        .then(() => {
          this.http.get(this.baseUrl + 'customer/' + this.customerId + '/edit?token=' + this.token)
          .subscribe((response: any) => {
            this.utilService.loadingDismiss();
            this.customerData = response.results.data;
            this.phone = (this.customerData.phone);
            this.customerName = this.customerData.customer_name;
            this.email = this.customerData.email;
            this.identityNumber =this.customerData.identity_number;
            this.referralCode = this.customerData.referral_code;
            this.firstReceiptNo = this.customerData.first_receipt_no ? this.customerData.first_receipt_no : '';
            this.birthPlace= this.customerData.birth_place;
            this.birthDate = this.customerData.birth_date;
            this.gender = this.customerData.gender;
            this.profession = this.customerData.profession;
            this.address = this.customerData.address;
            this.tierName = this.customerData.tier_name ? this.customerData.tier_name :'';
            this.tierStartDate = this.customerData.tier_start_date ? this.customerData.tier_start_date :'';
            this.currentPoint = this.customerData.current_point ? this.customerData.current_point :'0';
            this.status = this.customerData.active;
            this.banReason = this.customerData.banned_reason;

            this.countryData = response.results.country;
            this.provinceData = response.results.province;
            this.cityData = response.results.city;
            this.districtData = response.results.district;
            this.subdistrictData = response.results.subdistrict;
            this.countryId = this.customerData.country_id;
            this.provinceId = this.customerData.province_id;
            this.cityId = this.customerData.city_id;
            this.districtId = this.customerData.district_id;
            this.counterData = response.results.counter;
            this.counterId = this.customerData.registration_counter;
            this.subdistrictId = this.customerData.subdistrict_id;
            this.counterId = this.customerData.registration_counter;
            this.pointHistory = response.results.point_histories;
            this.memberVouchers = response.results.member_vouchers;
            this.memberHistory = response.results.member_history;
            this.showReferralCode = response.results.show_referral_code;
          }, () => {
            this.utilService.loadingDismiss();
            this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
          });
        });
      });
    }
    
  getTipeMutasi(type: string): string {
    switch(type) {
      case 'I': return 'Poin Masuk';
      case 'V': return 'Poin Masuk';
      case 'X': return 'Poin Expired';
      case 'O': return 'Poin Keluar';
      case 'VP': return 'Poin Keluar';
      default: return '-';
    }
  }

  formatDate(dateStr: string): string {
    const date = new Date(dateStr);
    return date.toLocaleDateString('id-ID', {
      year: 'numeric', month: 'long', day: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  }
  formatOnlyDate(dateStr: string): string {
    const date = new Date(dateStr);
    return date.toLocaleDateString('id-ID', {
      year: 'numeric', month: 'long', day: 'numeric'
    });
  }
  getVoucherStatusColor(status: string): string {
  switch (status) {
    case 'actived':
      return 'success'; // Hijau
    case 'expired':
      return 'danger';  // Merah
    case 'used':
      return 'warning'; // Kuning / oranye
    default:
      return 'medium';  // Abu-abu
  }
}

getVoucherStatusLabel(status: string): string {
  switch (status) {
    case 'active':
      return 'Aktif';
    case 'expired':
      return 'Kadaluarsa';
    case 'used':
      return 'Sudah Digunakan';
    default:
      return 'Tidak Diketahui';
  }
}

}
